import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Wishlist, WishlistState } from "../../types/wishListType";
import { api } from "../../config/Api";
import { authSlice } from '../AuthSlice';
import { AddItemRequest } from "./CartSlice";

const initialState: WishlistState = {
    wishlist: null,
    loading: false,
    error: null,
};

export const getWishlistByUserId = createAsyncThunk<Wishlist>(
    "wishlist/getWishlistByUserId",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get("/api/wishlist");
         
            return response.data;
        } catch (error: any) {
            
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch wishlist"
            );
        }
    }
);

export const addProductToWishlist = createAsyncThunk<Wishlist, AddItemRequest>(
    "wishlist/addProductToWishlist",
    async (
        item,
        { rejectWithValue }
    ) => {
        try {
            const response = await api.post(
                "/api/wishlist/addProduct",item
            );
            
            return response.data;
        } catch (error: any) {
          
            return rejectWithValue(
                error.response?.data?.message || "Failed to add product to wishlist"
            );
        }
    }
);

export const deleteWishList = createAsyncThunk<Wishlist,number>(
    "wishlist/deleteWishList",
    async (productDetailId, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/api/wishlist/${productDetailId}`);
            
            return response.data;
        } catch (error: any) {
        
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch wishlist"
            );
        }
    }
);

//Slice

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        resetWishlistState: (state) => {
            state.wishlist = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // getWishlistByUserId
        builder
        .addCase(getWishlistByUserId.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(
                getWishlistByUserId.fulfilled,
                (state, action: PayloadAction<Wishlist>) => {
                    state.wishlist = action.payload;
                    state.loading = false;
                }
            )
            .addCase(getWishlistByUserId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            //   add to wishlist

            .addCase(addProductToWishlist.pending, (state) => {
                state.loading = true;
                state.error = null;
            }).addCase(
                addProductToWishlist.fulfilled,
                (state, action: PayloadAction<Wishlist>) => {
                    state.wishlist = action.payload;
                    state.loading = false;
                }
            )
            .addCase(addProductToWishlist.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(deleteWishList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
                .addCase(
                    deleteWishList.fulfilled,
                    (state, action: PayloadAction<Wishlist>) => {
                        state.wishlist = action.payload;
                        state.loading = false;
                    }
                )
                .addCase(deleteWishList.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload as string;
                })
    
    },
});

export const wishListSliceReducer = wishlistSlice.reducer